<!-- Versão Desktop -->
<div *ngIf="device == 'desktop'" class="card dashboard-container" [class.dashboard-grafico]="exibirGraficos" [attr.data-grafico]="exibirGraficos">
    <p-toolbar styleClass="mb-4 dashboard-toolbar">
        <div class="formgrid p-fluid grid col-12 align-items-end">
            <div class="field col-12 md:col-12 xl:col-3 mb-0">
                <label for="estacao" class="dashboard-filter-label">Estação</label>
                <p-dropdown appendTo="body" inputId="estacao" [filter]="true"
                    optionLabel="label" optionValue="value"
                    filterBy="label,cliente,nomeEstacao,flu,plu,id"
                    filterLocale="pt-BR" [options]="dropDownEstacao" [(ngModel)]="estacao_id">
                </p-dropdown>
            </div>

            <div class="field col-12 md:col-12 xl:col-4 mb-0">
                <p-floatlabel>
                    <p-datepicker #range appendTo="body" dateFormat="dd/mm/yy"
                        [(ngModel)]="rangeDate" selectionMode="range" inputId="range">
                    </p-datepicker>
                    <label for="range">Período</label>
                </p-floatlabel>
            </div>


            <div *ngIf="exibirFiltroAvancado" class="formgrid p-fluid grid col-12 mt-2">
                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1 text-sm font-medium">Grupos</label>
                    <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                        optionLabel="label" placeholder="Selecione os grupos">
                    </p-multiSelect>
                </div>

                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1 text-sm font-medium">Cliente</label>
                    <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                        optionLabel="label" placeholder="Selecione os clientes">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-4">
                    <label class="block mb-1 text-sm font-medium">Sensores</label>
                    <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                        optionLabel="label" placeholder="Selecione os sensores">
                    </p-multiSelect>
                </div>

                <div class="field col-12 md:col-12 xl:col-3">
                    <label class="block mb-1 text-sm font-medium">PLU</label>
                    <input type="text" placeholder="PLU" [(ngModel)]="plu_filtro" pInputText class="w-full">
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <label class="block mb-1 text-sm font-medium">FLU</label>
                    <input type="text" placeholder="FLU" [(ngModel)]="flu_filtro" pInputText class="w-full">
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <label class="block mb-1 text-sm font-medium">Integrador</label>
                    <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                        [(ngModel)]="integrador_filtro" optionLabel="descricao" placeholder="Selecione os integradores">
                    </p-multiSelect>
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <label class="block mb-1 text-sm font-medium">Coletor</label>
                    <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                        [(ngModel)]="coletor_filtro" optionLabel="descricao" placeholder="Selecione os coletores">
                    </p-multiSelect>
                </div>

                <div class="field col-12 md:col-12 xl:col-3 flex align-items-end" *ngIf="isUsuarioInterno">
                    <button pButton pRipple type="button" label="Novo grupo de estação" (click)="addNovoGrupo()"
                        icon="pi pi-plus" class="p-button-success w-full"></button>
                </div>
            </div>

            <div class="field col-12 md:col-12 xl:col-2 mb-0">
                <button pButton pRipple pTooltip="Filtrar" (click)="filtrar()" type="button" icon="pi pi-search"
                    class="p-button-rounded p-button-success"></button>
                <button pButton pRipple type="button" (click)="toggleFiltroAvancado()" pTooltip="Filtro avançado"
                    icon="pi pi-filter" class="p-button-rounded p-button-text p-button-plain ml-2"></button>

                <button pButton pRipple type="button" (click)="gerarPDF()" pTooltip="Exportar para PDF"
                    icon="pi pi-file-pdf" class="p-button-rounded p-button-help ml-2"
                    [disabled]="!dadosVariavel || dadosVariavel.length === 0">
                </button>
                <button pButton pRipple type="button" (click)="gerarPDFA4Vertical()"
                    pTooltip="Exportar PDF A4 retrato (3 gráficos por página, estação e período no topo)"
                    icon="pi pi-file-pdf" class="p-button-rounded p-button-secondary ml-2"
                    [disabled]="!dadosVariavel || dadosVariavel.length === 0">
                </button>
            </div>


        </div>


    </p-toolbar>


    <div *ngIf="dados_nao_encontrados == false" class="p-fluid grid gap-0 col-12">
        <div class="col-12" *ngIf="exibirCabecalhoRelatorio">
            <section class="report-header-card">
                <div class="report-header-main">
                    <div class="report-header-title-wrap">
                        <span class="report-header-kicker">Relatórios da estação</span>
                        <h3 class="report-header-title">{{ descricao_estacao || 'Estação não identificada' }}</h3>
                    </div>
                    <div class="report-header-actions" *ngIf="dadosVariavel && dadosVariavel.length > 0">
                        <button pButton pRipple icon="pi pi-file-excel" class="p-button-rounded p-button-success mr-2"
                            (click)="exportarTabelaExcel()"></button>

                        <button pButton pRipple icon="pi pi-file-pdf" class="p-button-rounded p-button-warning mr-2"
                            (click)="exportarTabelaPdf()"></button>
                    </div>
                    <div class="report-header-meta">
                        <span class="report-chip" *ngIf="clienteRelatorio">
                            <span class="report-chip-label">Cliente</span>
                            <span class="report-chip-value">{{ clienteRelatorio }}</span>
                        </span>
                        <span class="report-chip" *ngIf="horaLeituraRelatorio">
                            <span class="report-chip-label">Última leitura</span>
                            <span class="report-chip-value">{{ horaLeituraRelatorio }}</span>
                        </span>
                        <span class="report-chip" *ngIf="pluRelatorio">
                            <span class="report-chip-label">PLU</span>
                            <button pButton pRipple type="button" class="p-button-link p-0 report-chip-link"
                                (click)="abrirSerieHistoricaSnirh(pluRelatorio, 'PLU')">
                                {{ pluRelatorio }}
                            </button>
                        </span>
                        <span class="report-chip" *ngIf="fluRelatorio">
                            <span class="report-chip-label">FLU</span>
                            <button pButton pRipple type="button" class="p-button-link p-0 report-chip-link"
                                (click)="abrirSerieHistoricaSnirh(fluRelatorio, 'FLU')">
                                {{ fluRelatorio }}
                            </button>
                        </span>
                        <span class="report-chip" *ngIf="serialTransmissorRelatorio">
                            <span class="report-chip-label">Serial do transmissor</span>
                            <span class="report-chip-value">{{ serialTransmissorRelatorio }}</span>
                        </span>
                        <span class="report-chip report-chip-monitoring" *ngIf="emMonitoramentoRelatorio">
                            <span class="report-chip-value">Em monitoramento</span>
                        </span>
                    </div>
                </div>
            </section>
        </div>
        <!-- <div class="col-12 md:col-7 lg:col-7"> -->
        <div #chartsContainer class="col-12" *ngIf="exibirGraficos">
            <div *ngFor="let chart of jsonData; let i = index">
                <div class="flex align-items-center mb-2 col-12">
                    <h4>{{chart.tipo_variavel.tipo_variavel}}</h4>
                    <button *ngIf="exibirBotaoAjusteMargem(chart)" pButton pRipple type="button" icon="pi pi-sliders-h" class="p-button-rounded p-button-text ml-2"
                        (click)="abrirModalAjusteMargem(i)" pTooltip="Ajustar margem do gráfico"></button>
                </div>
                <!-- Adiciona um ID único para cada gráfico e define o tamanho -->
                <div [attr.id]="'chart-' + i" style="width: 100%; height: 400px;"></div>
            </div>
        </div>
        <!-- <div class="col-12 md:col-5 lg:col-5"> -->
        <div class="col-12 dashboard-content" *ngIf="exibirGraficos || exibirTabela">
            <app-variavel *ngIf="dadosVariavel && dadosVariavel.length > 0" [value]="dadosVariavel"
                [columns]="columnsVariavel" [descricao_estacao]="descricao_estacao" [estacaoColetas]="estacaoColetas"
                [exibirCabecalhoExportacao]="false"></app-variavel>
        </div>
    </div>

    <div *ngIf="mensagemEstacaoNaoSelecionada" class="formgrid p-fluid grid col-12">
        <p-message severity="info" text="Por favor, selecione uma estação para visualizar os dados." styleClass="mr-2"></p-message>
    </div>

    <div *ngIf="dados_nao_encontrados" class="formgrid p-fluid grid col-12">
        <p-message severity="warn" text="Nenhum registro foi encontrado!" styleClass="mr-2"></p-message>
    </div>






</div>

<!-- Versão Mobile -->
<div *ngIf="device == 'mobile'" class="dashboard-mobile">
    <div class="mobile-filters">
        <div class="mobile-field-estacao">
            <p-dropdown appendTo="body" inputId="estacao-mobile" [filter]="true"
                optionLabel="label" optionValue="value"
                filterBy="label,cliente,nomeEstacao,flu,plu,id"
                filterLocale="pt-BR" [options]="dropDownEstacao" [(ngModel)]="estacao_id" placeholder="Selecione a estação" [panelStyle]="{'width':'400px'}"
                styleClass="mobile-dropdown-estacao">
            </p-dropdown>
        </div>

        <div class="mobile-field-date-buttons">
            <div class="mobile-date-field">
                <p-datepicker #rangeMobile appendTo="body" dateFormat="dd/mm/yy" placeholder="Período"
                    [(ngModel)]="rangeDate" selectionMode="range" inputId="range-mobile" 
                    styleClass="mobile-calendar">
                </p-datepicker>
            </div>

            <div class="mobile-buttons-group">
                <button pButton pRipple pTooltip="Filtrar" (click)="filtrar()" type="button" icon="pi pi-search"
                    class="p-button-rounded p-button-success mobile-button"></button>
                <button pButton pRipple type="button" (click)="toggleFiltroAvancado()" pTooltip="Filtro avançado"
                    icon="pi pi-filter" class="p-button-rounded p-button-text p-button-plain mobile-button"></button>
            </div>
        </div>

        <div *ngIf="exibirFiltroAvancado" class="mobile-advanced-filters">
            <div class="mobile-field">
                <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                    optionLabel="label" placeholder="Grupos">
                </p-multiSelect>
            </div>

            <div class="mobile-field">
                <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                    optionLabel="label" placeholder="Cliente">
                </p-multiSelect>
            </div>
            <div class="mobile-field">
                <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                    optionLabel="label" placeholder="Sensores (Identificador)">
                </p-multiSelect>
            </div>
            <div class="mobile-field">
                <input type="text" placeholder="PLU" [(ngModel)]="plu_filtro" pInputText>
            </div>
            <div class="mobile-field">
                <input type="text" placeholder="FLU" [(ngModel)]="flu_filtro" pInputText>
            </div>
            <div class="mobile-field">
                <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                    [(ngModel)]="integrador_filtro" optionLabel="descricao" placeholder="Integrador">
                </p-multiSelect>
            </div>
            <div class="mobile-field">
                <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                    [(ngModel)]="coletor_filtro" optionLabel="descricao" placeholder="Coletor">
                </p-multiSelect>
            </div>
            <div class="mobile-field" *ngIf="isUsuarioInterno">
                <button pButton pRipple type="button" label="Novo grupo de estação" (click)="addNovoGrupo()"
                    icon="pi pi-plus" class="p-button-success"></button>
            </div>
        </div>
    </div>

    <div *ngIf="dados_nao_encontrados == false" class="dashboard-mobile-content">
        <section class="report-header-card mobile-report-header" *ngIf="exibirCabecalhoRelatorio">
            <div class="report-header-title-wrap">
                <span class="report-header-kicker">Relatórios da estação</span>
                <h3 class="report-header-title">{{ descricao_estacao || 'Estação não identificada' }}</h3>
            </div>
            <div class="report-header-actions" *ngIf="dadosVariavel && dadosVariavel.length > 0">
                <button pButton pRipple icon="pi pi-file-excel" class="p-button-rounded p-button-success mr-2"
                    (click)="exportarTabelaExcel()"></button>

                <button pButton pRipple icon="pi pi-file-pdf" class="p-button-rounded p-button-warning mr-2"
                    (click)="exportarTabelaPdf()"></button>
            </div>
            <div class="report-header-meta">
                <span class="report-chip" *ngIf="clienteRelatorio">
                    <span class="report-chip-label">Cliente</span>
                    <span class="report-chip-value">{{ clienteRelatorio }}</span>
                </span>
                <span class="report-chip" *ngIf="horaLeituraRelatorio">
                    <span class="report-chip-label">Última leitura</span>
                    <span class="report-chip-value">{{ horaLeituraRelatorio }}</span>
                </span>
                <span class="report-chip" *ngIf="pluRelatorio">
                    <span class="report-chip-label">PLU</span>
                    <button pButton pRipple type="button" class="p-button-link p-0 report-chip-link"
                        (click)="abrirSerieHistoricaSnirh(pluRelatorio, 'PLU')">
                        {{ pluRelatorio }}
                    </button>
                </span>
                <span class="report-chip" *ngIf="fluRelatorio">
                    <span class="report-chip-label">FLU</span>
                    <button pButton pRipple type="button" class="p-button-link p-0 report-chip-link"
                        (click)="abrirSerieHistoricaSnirh(fluRelatorio, 'FLU')">
                        {{ fluRelatorio }}
                    </button>
                </span>
                <span class="report-chip" *ngIf="serialTransmissorRelatorio">
                    <span class="report-chip-label">Serial do transmissor</span>
                    <span class="report-chip-value">{{ serialTransmissorRelatorio }}</span>
                </span>
                <span class="report-chip report-chip-monitoring" *ngIf="emMonitoramentoRelatorio">
                    <span class="report-chip-value">Em monitoramento</span>
                </span>
            </div>
        </section>
        <div #chartsContainer class="mobile-charts" *ngIf="exibirGraficos">
            <div *ngFor="let chart of jsonData; let i = index">
                <div class="flex align-items-center mb-2 col-12">
                    <h4>{{chart.tipo_variavel.tipo_variavel}}</h4>
                    <button *ngIf="exibirBotaoAjusteMargem(chart)" pButton pRipple type="button" icon="pi pi-sliders-h" class="p-button-rounded p-button-text ml-2"
                        (click)="abrirModalAjusteMargem(i)" pTooltip="Ajustar margem do gráfico"></button>
                </div>
                <div [attr.id]="'chart-' + i" style="width: 100%; height: 300px;"></div>
            </div>
        </div>
        <div class="mobile-content" *ngIf="exibirGraficos || exibirTabela">
            <app-variavel *ngIf="dadosVariavel && dadosVariavel.length > 0" [value]="dadosVariavel"
                [columns]="columnsVariavel" [descricao_estacao]="descricao_estacao" [estacaoColetas]="estacaoColetas"
                [exibirCabecalhoExportacao]="false"></app-variavel>
        </div>
    </div>

    <div *ngIf="mensagemEstacaoNaoSelecionada" class="formgrid p-fluid grid col-12">
        <p-message severity="info" text="Por favor, selecione uma estação para visualizar os dados." styleClass="mr-2"></p-message>
    </div>

    <div *ngIf="dados_nao_encontrados" class="formgrid p-fluid grid col-12">
        <p-message severity="warn" text="Nenhum registro foi encontrado!" styleClass="mr-2"></p-message>
    </div>
</div>

<p-dialog [(visible)]="modalNovoGrupo" header="Novo Grupo de estações"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}">
    <app-grupo-estacao-formulario (onSave)="aoSalvarNovoGrupo()"></app-grupo-estacao-formulario>
</p-dialog>

<p-dialog [(visible)]="exibirModalMargem" header="Ajustar Margem do Gráfico" [modal]="true"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '400px'}">

    <div class="p-fluid">
        <div *ngIf="valoresAtuaisGrafico" class="field mb-4 p-3 surface-100 border-round">
            <h4 class="mt-0 mb-2" style="font-size: 1rem; font-weight: 600;">Valores atuais dos dados</h4>
            <div class="grid">
                <div class="col-6">
                    <span class="p-text-secondary" style="font-size: 0.875rem;">Mínimo:</span>
                    <div class="font-bold" style="font-size: 1.25rem;">
                        {{ formatarValor(valoresAtuaisGrafico.minimo, jsonData[indiceGraficoSelecionado]?.tipo_variavel?.id) }}
                    </div>
                </div>
                <div class="col-6">
                    <span class="p-text-secondary" style="font-size: 0.875rem;">Máximo:</span>
                    <div class="font-bold" style="font-size: 1.25rem;">
                        {{ formatarValor(valoresAtuaisGrafico.maximo, jsonData[indiceGraficoSelecionado]?.tipo_variavel?.id) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="p-fluid" *ngIf="!usaMargemFixaEventosNoGraficoSelecionado()">
        <div class="field">
            <label for="margemPercentual">Margem Percentual (%)</label>
            <p-inputNumber id="margemPercentual" [(ngModel)]="margemPercentual" [min]="0" [max]="100" 
                [step]="1" suffix="%"></p-inputNumber>
        </div>
        
        <div class="field">
            <small class="p-text-secondary">
                Ao abrir, a escala fica 1 unidade abaixo do menor valor e 1 acima do maior valor do intervalo.
                A margem percentual só passa a valer depois de aplicar este ajuste.
            </small>
        </div>
    </div>

    <div class="p-fluid" *ngIf="usaMargemFixaEventosNoGraficoSelecionado()">
        <div class="field">
            <small class="p-text-secondary">
                Escala automática definida pelos eventos configurados, com margem fixa de 1 unidade.
            </small>
        </div>
    </div>

    <div class="p-fluid">
        <div class="field">
            <label for="limiteMinimo">Limite Mínimo Fixo</label>
            <p-inputNumber id="limiteMinimo" [(ngModel)]="limiteMinimoManual" [min]="null" [max]="null" 
                [mode]="'decimal'" [step]="0.01" [minFractionDigits]="0" [maxFractionDigits]="2"></p-inputNumber>
            <small class="p-text-secondary">
                Digite o valor fixo para o limite mínimo do eixo Y (deixe em branco para automático).
            </small>
        </div>
    </div>

    <div class="p-fluid">
        <div class="field">
            <label for="limiteMaximo">Limite Máximo Fixo</label>
            <p-inputNumber id="limiteMaximo" [(ngModel)]="limiteMaximoManual" [min]="null" [max]="null" 
                [mode]="'decimal'" [step]="0.01" [minFractionDigits]="0" [maxFractionDigits]="2"></p-inputNumber>
            <small class="p-text-secondary">
                Digite o valor fixo para o limite máximo do eixo Y (deixe em branco para automático).
            </small>
        </div>
    </div>
    
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times" 
            class="p-button-text" (click)="fecharModalMargem()"></button>
        <button pButton pRipple type="button" label="Aplicar" icon="pi pi-check" 
            class="p-button-primary" (click)="aplicarMargem()"></button>
    </ng-template>
</p-dialog>

<p-dialog
    [header]="snirhSerieHistoricaTitulo"
    [(visible)]="modalSnirhSerieHistorica"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '95vw' }"
    [contentStyle]="{ 'max-height': '80vh', overflow: 'auto' }">
    <div *ngIf="loadingSnirhSerieHistorica" class="snirh-loading">
        Carregando dados do SNIRH...
    </div>

    <div *ngIf="!loadingSnirhSerieHistorica && snirhSerieHistoricaHtml" class="snirh-resultado">
        <div [innerHTML]="snirhSerieHistoricaHtml"></div>
    </div>
</p-dialog>
